import logoImg from '../../assets/images/login-logo.png'

export default function AppLogoWhite() {
    return (
        <img className="" src={logoImg} alt="" />
    )
}